module.exports = __webpack_public_path__ + "../assets/img/c9f79d072be4d952ee1f6d0263f0b41a.svg";